import React from "react";

import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { selectEnableCustomBackupSchedules } from "Reducers/project/capabilities";

import * as A from "../ActivityList/ActivityList.styles";

import Backup from "./Backup";
import * as S from "./BackupsList.style";

import type { EnvironmentBackup } from "@packages/client";

interface BackupsListProps {
  backups: EnvironmentBackup[];
  category: "Manual" | "Automated";
  quantity: number;
  parent: string;
  name: string;
  projectId: string;
  environmentId: string;
  organizationId: string;
  getAllBackups: () => void;
}

const BackupsList = ({
  backups,
  category,
  quantity,
  parent,
  name,
  projectId,
  environmentId,
  organizationId,
  getAllBackups
}: BackupsListProps) => {
  const isCustomBackupSchedulesEnabled = useSelectorWithUrlParams(
    selectEnableCustomBackupSchedules
  );

  return (
    <A.ActivityListLayout>
      <A.ActivityListScroll>
        <A.ListContainer>
          <S.ListTitle>
            <S.ListCategory>{category}</S.ListCategory>
            <S.ListQuantity>({quantity})</S.ListQuantity>
          </S.ListTitle>
          {backups?.length &&
            backups.map(backup => (
              <Backup
                key={backup.id}
                backup={backup}
                parent={parent}
                name={name}
                projectId={projectId}
                environmentId={environmentId}
                organizationId={organizationId}
                getAllBackups={getAllBackups}
                isCustomBackupSchedulesEnabled={isCustomBackupSchedulesEnabled}
              />
            ))}
        </A.ListContainer>
      </A.ActivityListScroll>
    </A.ActivityListLayout>
  );
};

export default BackupsList;
